var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("h3", { staticClass: "mt-2 colorPulsing" }, [
        _vm._v("Wird an die Kasse übermittelt..."),
      ]),
      _c("div", { staticClass: "mt-2 mb-4", staticStyle: { opacity: "0.8" } }, [
        _vm._v("Diese Seite aktualisiert automatisch"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }